// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Load Rails Turbo support but *disable* Turbo Drive globally.
// To enable Turbo Drive on a per-element basis by annotating the element or any of its ancestors with `data-turbo="true"`.
// Wrap a segment of the page in a `<turbo-frame>` element to prevent Turbo from automatically update the entire page.
// check https://turbo.hotwired.dev/handbook/frames#turbo-frame for more information on turbo-frames.
import * as Turbo from '@hotwired/turbo'
Turbo.session.drive = false
// Lottie animation support
import '@lottiefiles/dotlottie-wc';

// Example: Load Rails libraries in Vite.
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
